import gql from 'graphql-tag';

export const ApproveOrganiserClaimByToken = gql`
  mutation ApproveOrganiserClaimByToken($token: String!) {
    approveOrganiserClaimByToken(token: $token) {
      organiserId
    }
  }
`;
